module.exports = __webpack_public_path__ + "ed5b03c192c556160c8eb6be76afa15d.gif";